
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Metal } from "@/lib/pricing";

interface MetalTabsProps {
  selectedMetal: Metal;
  onMetalChange: (value: string) => void;
}

export function MetalTabs({ selectedMetal, onMetalChange }: MetalTabsProps) {
  return (
    <TabsList className="grid grid-cols-2">
      <TabsTrigger value="ORO" className="relative">
        ORO
        <span className="absolute -top-1 -right-1 bg-yellow-500 h-2 w-2 rounded-full"></span>
      </TabsTrigger>
      <TabsTrigger value="ARGENTO" className="relative">
        ARGENTO
        <span className="absolute -top-1 -right-1 bg-gray-300 h-2 w-2 rounded-full"></span>
      </TabsTrigger>
    </TabsList>
  );
}
